import { Component, OnInit, ViewChild } from '@angular/core';
import { QuillEditorComponent } from 'ngx-quill';
import { PopoverRef } from 'src/@vex/components/popover/popover-ref';
import { IExam, IExamInstruction } from 'src/app/interface/dto';
import { examDefault } from 'src/app/interface/dtoDefaults';
import { ExamService } from 'src/app/services/exam-service.service';
import { SnackbarService } from 'src/app/services/snackbar.service';

@Component({
  selector: 'app-exam-instructions',
  templateUrl: './exam-instructions.component.html',
  styleUrls: ['./exam-instructions.component.scss']
})
export class ExamInstructionsComponent implements OnInit {
  exam: IExam = examDefault;
  examInstruction: IExamInstruction = {
    examinationID: 0,
    instructions: ''
  };
  @ViewChild('editor') editor: QuillEditorComponent;

  constructor(private popoverRef: PopoverRef<ExamInstructionsComponent>,
    private examsevice: ExamService, private snackBar: SnackbarService,) { }

  async ngOnInit() {
    if (this.examsevice.selectedExams.length === 1) {
      this.exam = this.examsevice.selectedExams[0];
    }

    await this.examsevice.getExamInstructions(this.exam.id).then((ins: any) => {
      this.examInstruction = ins;
      this.editor.quillEditor.clipboard.dangerouslyPasteHTML(this.examInstruction.instructions);
    });
  }

  close() {
    this.popoverRef.close();
  }
  async ngAfterViewInit() {
    this.editor.onEditorCreated.subscribe(() => {
      this.editor.quillEditor.clipboard.dangerouslyPasteHTML(this.examInstruction.instructions);
    });
  }
  saveInstruction() {
    this.examInstruction.examinationID = this.exam.id;
    this.examsevice.saveExamInstructions(this.examInstruction).then((s: any) => {
      this.snackBar.success('Instruction Saved');
    });
  }

}
